import SmartButton from "../buttons/SmartButton";

function AdminCard({ data, fields, actions }) {
  return (
    <div className="admin-card">
      {data.address && (
        <div className="admin-card-address">
          <h4>{data.address.title}</h4>
          <p>{data.address.value}</p>
        </div>
      )}
      <div className="admin-card-info">
        {fields.map((field) => (
          <div key={field.key}>
            <strong>{field.label}</strong>
            <span>{field.getValue(data)}</span>
          </div>
        ))}
      </div>
      {actions && (
        <div className="admin-card-actions">
          {actions.map((action) => (
            <SmartButton
              key={action.key}
              text={action.text}
              icon={action.icon}
              onClick={() => action.onClick(data)}
              className={action.className}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default AdminCard;
